export const StatusEnum: { [index: number]: string } = {
  0: 'Inativo',
  1: 'Ativo',
}
